export enum FiatTransactionStatus {
    UNCONFIRMED = 'UNCONFIRMED',
    PENDING = 'PENDING',
    DONE = 'DONE',
    CANCELED = 'CANCELED',
    PROCESSING = 'PROCESSING'
}
